import { Link } from "react-router-dom";
import Seo from "../Components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Seite nicht gefunden"
        description="Die angeforderte Seite existiert nicht."
        path="/404"
      />
      <div className="notfound">
        <div>
          <p className="kicker">404</p>
          <h1 className="display">Dieser Raum ist leer.</h1>
          <p className="muted" style={{ margin: "1rem 0 1.5rem" }}>
            Die Seite gibt es nicht – der Weg zurück schon.
          </p>
          <Link className="btn btn-navy" to="/">
            Zur Startseite
          </Link>
        </div>
      </div>
    </>
  );
}
